





































import Vue from 'vue';

// Project components
import Header from '~/components/layouts/Header.vue';
import MainLayout from '~/components/layouts/mainlayout/MainLayout.vue';
import SearchModule from '~/shared/searchmodule/SearchModule.vue';
import ProfileModule from '~/components/smart/ProfileModule/ProfileModule.vue';
import CompanyList from '~/shared/CompanyList.vue';
import FeaturedPositions from '~/components/smart/FeaturedPositions.vue';
import FeaturedCompanies from '~/components/smart/FeaturedCompanies.vue';
import Pagination from '~/components/miscellaneous/Pagination.vue';
import FeaturedResource from '~/components/smart/FeaturedResource.vue';
import WidgetModule from '~/components/smart/WidgetModule.vue';

// Utils imports
import mapSelectedToFilters from '~/utils/mappers/mapSelectedToFilters';
import emptySelected from '~/utils/emptySelected';
import {
    FEATURE_COMPANIES_MODULE,
    FEATURE_POSITIONS_MODULE,
    SHOW_CHAT_IN_COMPANY_LIST,
} from '~/router';
import { OrganizationV2 } from '~/models';
import CompanyService from '~/services/CompanyService';

// Assets
import WarningSvg from '~/assets/img/warning.svg';

// Constants
const PAGE_SIZE = 48;

type ExtendedOrganizationV2 = OrganizationV2 & { name: string };

export default Vue.extend({
    name: 'FindCompanies',
    components: {
        Header,
        MainLayout,
        SearchModule,
        ProfileModule,
        CompanyList,
        FeaturedPositions,
        FeaturedCompanies,
        Pagination,
        FeaturedResource,
        WidgetModule,
    },
    data: () => ({
        selected: null,
        page: 1,
        showFeaturedCompanies: FEATURE_COMPANIES_MODULE,
        showFeaturedPositions: FEATURE_POSITIONS_MODULE,
        companies: [] as ExtendedOrganizationV2[],
        loading: false,
        isError: false,

        assetWarning: WarningSvg,
    }),
    methods: {
        fetchCompanies(page: number, limit: number): Promise<ExtendedOrganizationV2[]> {
            return CompanyService.getCompanies({
                ...mapSelectedToFilters(this.selected),
                page,
                limit,
                minified: true,
                subdomain: 'gethighered',
                order: 'title',
            }).then(response => {
                return response.data.map((company: OrganizationV2) => {
                    return {
                        ...company,
                        name: company.title,
                    };
                });
            });
        },
        loadFirstPage() {
            this.companies = [];
            this.loading = true;
            this.isError = false;
            this.page = 1;
            this.fetchCompanies(this.page, PAGE_SIZE)
                .then((companies: ExtendedOrganizationV2[]) => {
                    this.companies = companies;
                })
                .catch(() => {
                    this.isError = true;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        loadNextPage() {
            if (this.loading) {
                return;
            }

            this.loading = true;
            this.page++;
            this.fetchCompanies(this.page, PAGE_SIZE)
                .then((companies: ExtendedOrganizationV2[]) => {
                    this.companies = [...this.companies, ...companies];
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        clearFilters() {
            this.selected = emptySelected(this.filters());
        },
        filters(): string[] {
            return ['query'];
        },
    },
    watch: {
        selected() {
            this.loadFirstPage();
        },
    },
    mounted() {
        this.selected = emptySelected(this.filters());
        if (SHOW_CHAT_IN_COMPANY_LIST) {
            // @ts-ignore
            this.$interfaces.communication.chat.availability.summary.get({ forceUpdate: true });
        }

        this.loadFirstPage();
    },
});
